export default "__VITE_ASSET__Bx2$R$9h__"